$(document).ready(function(){
  
  
  $('.faq_title').click(function(){
    $(this).parent().siblings().find('.faq_ans').slideUp(300);
    $(this).parent().siblings().find('.faq_arrow').removeClass('active');
    $(this).next().slideToggle(300);
    $(this).parent().find('.faq_arrow').toggleClass('active');
  });

  $('.cust_article_none').slice(0,4).show();
  $(".show_more_article").click(function(){
    $(".cust_article_none:hidden").slice(0,4).show();
    
    if($(".cust_article_none:hidden").length == 0){
       $(".show_more_article").fadeOut("slow");
      }
  });

  $('.blog-articles__article').slice(0,6).show();
  $(".blog_show_more ").click(function(){
    $(".blog-articles__article:hidden").slice(0,6).show();
    
    if($(".blog-articles__article:hidden").length == 0){
       $(".blog_show_more").fadeOut("slow");
      }
  });
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * (24 * 60 * 60 * 1000)));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  setTimeout(function(){
    setCookie('cart_currency','USD',1)
  },1000);
});